<template>
  <div class="price mt-n1" :class="{['text-' + align ]: align }">
    <div class="price-srp caption">SRP</div>
    <div class="price-values bb-primary--text mt-n1">

      <slot name="left"/>

      <span class="price-old" v-if="offer && align !== 'left'">
        {{ format( price ) }}
      </span>
      <span class="price-value display-4">
        {{ format( offer || price ) }}
      </span>
      <span class="price-old" v-if="offer && align === 'left'">
        {{ format( price ) }}
      </span>

      <slot name="right"/>

    </div>
  </div>
</template>

<script>
import { euros } from '@/utils/partSpecs';

export default {
  props: {
    price: Number,
    offer: Number,
    align: {
      type: String,
      default: 'left'
    }
  },
  methods: {
    // Same shop format as every part card: 13.681,80 € / 4.800 €.
    format( value ) { return euros( Number( value ) || 0 ); }
  }
}
</script>

<style>
.price {
  text-align: left;
}
.price-srp {
  line-height: 1.4;
  font-size: .6rem !important;
}
.price-value, .price-old {
  white-space: nowrap;
}
.price-old {
  text-decoration: line-through;
  font-weight: bold;
  opacity: .25;
}
</style>
